<div class="job-matrix-header">
  <div class="filter-header">
    <h1
      class="job-matrix-title"
      data-cy="job-matrix-title">
      {{ ("jobMatrix" | i18n) || "Anfragenübersicht" }}
    </h1>
    <div class="filter-actions">
      <button
        mat-stroked-button
        class="filter-button"
        [class.collapsed]="filtersCollapsed"
        (click)="toggleFilters()"
        data-cy="job-matrix-collapse-filter-button"
        type="button">
        <div class="filter-button-content">
          <mat-icon svgIcon="filter_alt_outline"></mat-icon>
          <span class="mat-fab__label">{{
            ("filter" | i18n) || "Filter"
          }}</span>
          <span
            *ngIf="filterCounts"
            class="badge"
            data-cy="count-badge">
            {{ filterCounts }}
          </span>
        </div>
      </button>
    </div>
  </div>
  <div
    class="collapse-wrapper collapse-filter"
    [class.collapsed]="filtersCollapsed"
    data-cy="collapse-filter">
    <div class="collapse-child">
      <div class="row">
        <div class="col col-md-6 col-lg-3">
          <app-job-type-multiselect
            [useQueryParam]="'jobtypes'"
            [lightFormField]="true"
            data-cy="job-type-filter">
          </app-job-type-multiselect>
        </div>
        <div class="col col-md-6 col-lg-3">
          <mat-form-field class="light-form-field time-selection">
            <mat-label>{{ ("date" | i18n) || "Datum" | titlecase }}</mat-label>
            <mat-date-range-input
              class="date-range-input"
              [rangePicker]="picker">
              <input
                #startDateInput
                matStartDate
                name="fromDate"
                [ngModel]="fromParamDate$ | async"
                (ngModelChange)="onFromDateInput($event)"
                (click)="picker.open()"
                placeholder="dd.mm.yyyy"
                maxlength="10" />
              <input
                #endDateInput
                matEndDate
                name="toDate"
                [ngModel]="toParamDate$ | async"
                (ngModelChange)="onToDateInput($event)"
                (click)="picker.open()"
                placeholder="dd.mm.yyyy"
                maxlength="10" />
            </mat-date-range-input>
            <mat-icon
              *ngIf="(fromParamDate$ | async) && (toParamDate$ | async)"
              svgIcon="close"
              class="clear-date-icon"
              (click)="clearDates(); $event.stopPropagation()"></mat-icon>
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="col col-md-6 col-lg-3">
          <app-shift-select [useQueryParam]="'shifts'"></app-shift-select>
        </div>
        <div class="col col-md-6 col-lg-3">
          <app-certificate-multiselect
            [allCertificates]="(customerCertificates$ | async) || []"
            [certificateGroups]="(customerCertificateGroups$ | async) || []"
            [useQueryParam]="'certificates'"></app-certificate-multiselect>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-slide-toggle
            *ngIf="showSectionToggle$ | async"
            [checked]="groupByOrganisation$ | async"
            (change)="toggleGroupByOrganisation()"
            class="grouping-toggle"
            data-cy="job-matrix-grouping-toggle">
            {{
              ("groupBy" | i18n) +
                ((groupByOrganisation$ | async)
                  ? ("organisation" | i18n)
                  : ("section" | i18n))
            }}
          </mat-slide-toggle>
        </div>
        <div class="col">
          <div class="filter-action-buttons">
            <button
              mat-button
              class="clear-filter-button"
              (click)="clearAllFilters()"
              data-cy="clear-filter-button">
              <div class="filter-actions-button-content">
                <mat-icon svgIcon="delete-trash-remove"></mat-icon>
                {{ ("clearAllFilters" | i18n) || "Filter löschen" }}
              </div>
            </button>
            <button
              mat-button
              class="save-filter-button"
              (click)="saveDefaultFilter()"
              data-cy="save-filter-button">
              <div class="filter-actions-button-content">
                <mat-icon
                  svgIcon="save"
                  size></mat-icon>
                {{ ("saveDefaultFilter" | i18n) || "Filter speichern" }}
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="organisationRows$ | async as organisationRows">
  <ng-container *ngIf="organisationRows.length > 0">
    <div
      class="job-matrix-table-wrapper"
      data-cy="job-matrix-table-wrapper">
      <div class="side-scroll-table job-matrix-custom-table">
        <ng-container *ngIf="calendarTableHelper$ | async as calendarHelper">
          <div
            class="table-header-row"
            data-cy="table-header-row">
            <div class="sticky-header-cell-left header-label-cell"></div>
            <div class="header-rows">
              <div
                class="months-wrapper"
                data-cy="months-wrapper">
                <ng-container *ngFor="let monthGroup of calendarHelper.months">
                  <div class="month-wrapper">
                    <div
                      class="month-name"
                      *ngIf="monthGroup.days.length > 2"
                      data-cy="month-name">
                      {{ monthGroup.days[0].date | date: "MMMM yyyy" }}
                    </div>
                    <div class="hidden-days">
                      <ng-container *ngFor="let day of monthGroup.days">
                        <div class="hidden-day-container">
                          <div
                            *ngFor="let shiftInfo of effectiveShifts$ | async"
                            class="hidden-day"
                            [class.is-first-week-day]="
                              day.totalIndex === 0 ||
                              (day.date | date: 'cc') === '1'
                            "
                            [class.is-weekend]="
                              (day.date | date: 'cc') === '6' ||
                              (day.date | date: 'cc') === '0'
                            "
                            [class.is-today]="
                              (day.date | date: 'yyyy.MM.dd') === getToday() &&
                              (calendarHelper.start | date: 'yyyy.MM.dd') !==
                                getToday()
                            "></div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
              </div>
              <div
                class="weeks-wrapper"
                data-cy="weeks-wrapper">
                <ng-container *ngFor="let weekGroup of calendarHelper.weeks">
                  <div class="week-wrapper">
                    <div
                      class="calendar-week"
                      data-cy="calendar-week">
                      {{ "KW" + " " + weekGroup.weekNumber }}
                    </div>
                    <div class="hidden-days">
                      <ng-container *ngFor="let day of weekGroup.days">
                        <div class="hidden-day-container">
                          <div
                            *ngFor="let shiftInfo of effectiveShifts$ | async"
                            class="hidden-day"
                            [class.is-first-week-day]="
                              day.totalIndex === 0 ||
                              (day.date | date: 'cc') === '1'
                            "
                            [class.is-weekend]="
                              (day.date | date: 'cc') === '6' ||
                              (day.date | date: 'cc') === '0'
                            "
                            [class.is-today]="
                              (day.date | date: 'yyyy.MM.dd') === getToday() &&
                              (calendarHelper.start | date: 'yyyy.MM.dd') !==
                                getToday()
                            "></div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
              </div>
              <div
                class="days-wrapper"
                data-cy="days-wrapper">
                <ng-container
                  *ngFor="
                    let date of dateRangeDates$ | async;
                    let dayIndex = index
                  ">
                  <div
                    class="date-container"
                    [class.is-first-week-day]="
                      dayIndex === 0 || (date | date: 'cc') === '1'
                    "
                    [class.is-weekend]="
                      (date | date: 'cc') === '6' || (date | date: 'cc') === '0'
                    "
                    [class.is-today]="
                      (date | date: 'yyyy.MM.dd') === getToday()
                    "
                    [attr.data-cy]="
                      'date-container-' +
                      date +
                      ((date | date: 'yyyy.MM.dd') === getToday()
                        ? '-is-today'
                        : '')
                    ">
                    <div class="date-main-header">
                      <div
                        class="date-part"
                        data-cy="date-part">
                        {{ date | date: "dd" }}
                      </div>
                      <div
                        class="week-day"
                        data-cy="week-day">
                        {{ (date | date: "EEEE")?.slice(0, 2) }}
                      </div>
                    </div>
                    <div class="shifts-headers-container">
                      <div
                        *ngFor="let shiftInfo of effectiveShifts$ | async"
                        class="shift-header-cell"
                        [attr.data-cy]="
                          'shift-header-' + date + '-' + shiftInfo.shift
                        ">
                        <div
                          class="shift-header-label"
                          data-cy="shift-header-label">
                          {{ shiftInfo.displayName }}
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Total certificate combinations -->
        <ng-container *ngIf="totalJobsRow$ | async as totalJobsRow">
          <ng-container
            *ngFor="
              let certRow of certificateRows$ | async;
              let isFirst = first;
              let isLast = last
            ">
            <div
              class="table-row total-row"
              [class.first-of-total]="isFirst"
              [class.last-of-total]="isLast"
              data-cy="total-row"
              [attr.data-cy-first]="isFirst ? '' : null"
              [attr.data-cy-last]="isLast ? '' : null">
              <div
                class="table-cell main-label-cell sticky-main-cell-left total-header-cell"
                [class.certificate-only-row]="!isFirst"
                [attr.data-cy]="
                  'total-cert-row-' +
                  certRow.id +
                  (isFirst ? '' : '-certificate-only-row')
                ">
                <div
                  class="total-header-label"
                  [class.certificate-only]="!isFirst">
                  <div
                    class="total-header-label-left"
                    *ngIf="isFirst">
                    <div
                      class="total-name-header"
                      data-cy="total-name-header">
                      {{ ("total" | i18n) || "Gesamt" }}
                    </div>
                  </div>
                  <div
                    class="total-header-label-right"
                    data-cy="total-header-label-right">
                    <div
                      class="certificate-name-wrapper"
                      [title]="certRow.name">
                      {{ certRow.name }}
                    </div>
                  </div>
                </div>
              </div>
              <ng-container *ngFor="let date of dateRangeDates$ | async">
                <div
                  class="date-data-container"
                  [class.is-today]="(date | date: 'yyyy.MM.dd') === getToday()"
                  [class.is-weekend]="
                    (date | date: 'cc') === '6' || (date | date: 'cc') === '0'
                  "
                  [attr.data-cy]="
                    'total-cert-data-container-' + certRow.id + '-' + date
                  ">
                  <div
                    *ngFor="let shiftInfo of effectiveShifts$ | async"
                    class="table-cell data-cell total-header-data-cell shift-column"
                    [class.certificate-only-data-cell]="!isFirst"
                    [attr.data-cy]="
                      'total-cert-shift-data-' +
                      certRow.id +
                      '-' +
                      date +
                      '-' +
                      shiftInfo.shift
                    ">
                    <div class="job-count-display">
                      <ng-container
                        *ngIf="
                          totalJobsRow.byCertificates
                            ?.get(certRow.id)
                            ?.byDate?.get(date)
                            ?.byShift?.get(shiftInfo.shift) as certJobCount
                        ">
                        <div
                          class="job-data-container"
                          *ngIf="
                            certJobCount.open > 0 || certJobCount.closed > 0
                          "
                          (click)="
                            openJobDetailsSideSheet(certJobCount.jobIds, date)
                          "
                          data-cy="clickable-job-count">
                          <!-- Bar graph -->
                          <div
                            class="job-bar-graph"
                            *ngIf="totalJobsRow.maxJobs > 0"
                            data-cy="job-bar-graph"
                            [style.--max-count]="totalJobsRow.maxJobs"
                            [style.--open-count]="certJobCount.open"
                            [style.--closed-count]="certJobCount.closed">
                            <div class="bar-container">
                              <div class="bar-segment open-bar"></div>
                              <div class="bar-segment closed-bar"></div>
                            </div>
                          </div>

                          <!-- Job counts -->
                          <div
                            class="job-counts"
                            data-cy="job-counts">
                            <span
                              class="open-count"
                              data-cy="open-count">
                              {{
                                certJobCount.open > 0 ? certJobCount.open : "-"
                              }}
                            </span>
                            <span
                              class="closed-count"
                              data-cy="closed-count">
                              {{
                                certJobCount.closed > 0
                                  ? certJobCount.closed
                                  : "-"
                              }}
                            </span>
                          </div>
                        </div>
                        <div
                          class="job-data-container empty-cell"
                          *ngIf="
                            certJobCount.open === 0 && certJobCount.closed === 0
                          ">
                          <!-- Job counts -->
                          <div
                            class="job-counts"
                            data-cy="job-counts">
                            <span
                              class="no-jobs-indicator"
                              data-cy="no-jobs-indicator"
                              >-</span
                            >
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngFor="let orgRow of organisationRows">
          <ng-container
            *ngFor="
              let certificateRow of certificateRows$ | async;
              let isFirst = first;
              let isLast = last
            ">
            <div
              class="table-row organisation-row"
              [class.first-of-organisation]="isFirst"
              [class.last-of-organisation]="isLast"
              [class.collapsed]="orgRow.detailsCollapsed"
              data-cy="organisation-row"
              [attr.data-cy-first]="isFirst ? '' : null"
              [attr.data-cy-last]="isLast ? '' : null">
              <div
                class="table-cell main-label-cell sticky-main-cell-left organisation-header-cell"
                [class.certificate-only]="!isFirst"
                [attr.data-cy]="'org-header-' + orgRow.organisation.id">
                <div
                  class="organisation-header-label"
                  [class.certificate-only]="!isFirst">
                  <div
                    class="organisation-header-label-left"
                    (click)="orgRow.detailsCollapsed = !orgRow.detailsCollapsed"
                    *ngIf="isFirst">
                    <mat-icon
                      svgIcon="chevron-down"
                      class="organisation-toggle-icon"
                      [class.collapsed]="orgRow.detailsCollapsed">
                    </mat-icon>
                    <div
                      class="organisation-name-header"
                      [title]="orgRow.organisation.name">
                      {{ orgRow.organisation.name }}
                    </div>
                  </div>
                  <div
                    class="organisation-header-label-right"
                    data-cy="organisation-header-label-right">
                    <div
                      class="certificate-name-wrapper"
                      [title]="certificateRow.name">
                      {{ certificateRow.name }}
                    </div>
                  </div>
                </div>
              </div>
              <ng-container *ngFor="let date of dateRangeDates$ | async">
                <div
                  class="date-data-container"
                  [class.is-today]="(date | date: 'yyyy.MM.dd') === getToday()"
                  [class.is-weekend]="
                    (date | date: 'cc') === '6' || (date | date: 'cc') === '0'
                  "
                  [attr.data-cy]="
                    'org-header-data-container-' +
                    orgRow.organisation.id +
                    '-' +
                    date
                  ">
                  <div
                    *ngFor="let shiftInfo of effectiveShifts$ | async"
                    class="table-cell data-cell organisation-header-data-cell shift-column"
                    [attr.data-cy]="
                      'org-shift-data-' +
                      orgRow.organisation.id +
                      '-' +
                      date +
                      '-' +
                      shiftInfo.shift
                    ">
                    <div class="job-count-display">
                      <ng-container
                        *ngIf="
                          orgRow.jobs.byCertificates
                            .get(certificateRow.id)
                            ?.byDate?.get(date)
                            ?.byShift?.get(shiftInfo.shift) as orgJobCount
                        ">
                        <div
                          class="job-data-container"
                          *ngIf="orgJobCount.open > 0 || orgJobCount.closed > 0"
                          (click)="
                            openJobDetailsSideSheet(orgJobCount.jobIds, date)
                          "
                          data-cy="clickable-job-count">
                          <!-- Bar graph -->
                          <div
                            class="job-bar-graph"
                            *ngIf="orgRow.jobs.maxJobs > 0"
                            data-cy="job-bar-graph"
                            [style.--max-count]="orgRow.jobs.maxJobs"
                            [style.--open-count]="orgJobCount.open"
                            [style.--closed-count]="orgJobCount.closed">
                            <div class="bar-container">
                              <div class="bar-segment open-bar"></div>
                              <div class="bar-segment closed-bar"></div>
                            </div>
                          </div>

                          <!-- Job counts -->
                          <div
                            class="job-counts"
                            data-cy="job-counts">
                            <span
                              class="open-count"
                              data-cy="open-count">
                              {{
                                orgJobCount.open > 0 ? orgJobCount.open : "-"
                              }}
                            </span>
                            <span
                              class="closed-count"
                              data-cy="closed-count">
                              {{
                                orgJobCount.closed > 0
                                  ? orgJobCount.closed
                                  : "-"
                              }}
                            </span>
                          </div>
                        </div>
                        <div
                          class="job-data-container empty-cell"
                          *ngIf="
                            orgJobCount.open === 0 && orgJobCount.closed === 0
                          ">
                          <!-- Job counts -->
                          <div
                            class="job-counts"
                            data-cy="job-counts">
                            <span
                              class="no-jobs-indicator"
                              data-cy="no-jobs-indicator"
                              >-</span
                            >
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="!orgRow.detailsCollapsed">
            <ng-container
              *ngFor="
                let section of orgRow.sections || [];
                let isLastSectionGroup = last
              ">
              <!-- Section-certificate rows for this section -->
              <ng-container
                *ngFor="
                  let certificateRow of certificateRows$ | async;
                  let isFirstCertificateForSection = first;
                  let isLastCertificateForSection = last
                ">
                <div
                  class="table-row section-certificate-row"
                  data-cy="section-certificate-row">
                  <div
                    class="table-cell main-label-cell sticky-main-cell-left section-certificate-row-cell"
                    [class.certificate-only-row]="!isFirstCertificateForSection"
                    [attr.data-cy]="
                      'section-cert-row-' +
                      orgRow.organisation.id +
                      '-' +
                      section.name +
                      '-' +
                      (certificateRow.id || '')
                    ">
                    <div
                      class="section-certificate-label"
                      [class.certificate-only]="!isFirstCertificateForSection">
                      <div
                        class="section-header-label-left"
                        (click)="
                          section.detailsCollapsed = !section.detailsCollapsed
                        "
                        *ngIf="isFirstCertificateForSection">
                        <mat-icon
                          svgIcon="chevron-down"
                          class="section-toggle-icon"
                          [class.collapsed]="section.detailsCollapsed">
                        </mat-icon>
                        <div
                          class="section-name-header"
                          [title]="section.name">
                          {{ section.name }}
                        </div>
                      </div>
                      <div
                        class="section-header-label-right"
                        data-cy="section-header-label-right">
                        <div
                          class="certificate-name-wrapper"
                          [title]="certificateRow.name">
                          {{ certificateRow.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <ng-container *ngFor="let date of dateRangeDates$ | async">
                    <div
                      class="date-data-container"
                      [class.is-today]="
                        (date | date: 'yyyy.MM.dd') === getToday()
                      "
                      [class.is-weekend]="
                        (date | date: 'cc') === '6' ||
                        (date | date: 'cc') === '0'
                      "
                      [attr.data-cy]="
                        'section-cert-data-container-' +
                        orgRow.organisation.id +
                        '-' +
                        section.name +
                        '-' +
                        (certificateRow.id || '') +
                        '-' +
                        date
                      ">
                      <div
                        *ngFor="let shiftInfo of effectiveShifts$ | async"
                        class="table-cell data-cell section-certificate-data-cell shift-column"
                        [class.certificate-only-data-cell]="
                          !isFirstCertificateForSection
                        "
                        [attr.data-cy]="
                          'section-cert-shift-data-' +
                          orgRow.organisation.id +
                          '-' +
                          section.name +
                          '-' +
                          (certificateRow.id || '') +
                          '-' +
                          date +
                          '-' +
                          shiftInfo.shift
                        ">
                        <div class="job-count-display">
                          <ng-container
                            *ngIf="
                              section.jobs.byCertificates
                                .get(certificateRow.id)
                                ?.byDate?.get(date)
                                ?.byShift?.get(
                                  shiftInfo.shift
                                ) as sectionCertJobCount
                            ">
                            <div
                              class="job-data-container"
                              *ngIf="
                                sectionCertJobCount.open > 0 ||
                                sectionCertJobCount.closed > 0
                              "
                              (click)="
                                openJobDetailsSideSheet(
                                  sectionCertJobCount.jobIds,
                                  date
                                )
                              "
                              data-cy="clickable-job-count">
                              <!-- Bar graph -->
                              <div
                                class="job-bar-graph"
                                *ngIf="section.jobs.maxJobs > 0"
                                data-cy="job-bar-graph"
                                [style.--max-count]="section.jobs.maxJobs"
                                [style.--open-count]="sectionCertJobCount.open"
                                [style.--closed-count]="
                                  sectionCertJobCount.closed
                                ">
                                <div class="bar-container">
                                  <div class="bar-segment open-bar"></div>
                                  <div class="bar-segment closed-bar"></div>
                                </div>
                              </div>

                              <!-- Job counts -->
                              <div
                                class="job-counts"
                                data-cy="job-counts">
                                <span
                                  class="open-count"
                                  data-cy="open-count">
                                  {{
                                    sectionCertJobCount.open > 0
                                      ? sectionCertJobCount.open
                                      : "-"
                                  }}
                                </span>
                                <span
                                  class="closed-count"
                                  data-cy="closed-count">
                                  {{
                                    sectionCertJobCount.closed > 0
                                      ? sectionCertJobCount.closed
                                      : "-"
                                  }}
                                </span>
                              </div>
                            </div>
                            <div
                              class="job-data-container empty-cell"
                              *ngIf="
                                sectionCertJobCount.open === 0 &&
                                sectionCertJobCount.closed === 0
                              ">
                              <!-- Job counts -->
                              <div class="job-counts">
                                <span class="no-jobs-indicator">-</span>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-container>

              <!-- Department-certificate rows for this section -->
              <ng-container
                *ngFor="
                  let departmentRow of section.departments || [];
                  let isLast = last
                ">
                <ng-container *ngIf="!section.detailsCollapsed">
                  <ng-container
                    *ngFor="
                      let certificateRow of certificateRows$ | async;
                      let isFirstCertificateForDepartment = first;
                      let isLastCertificateForDepartment = last
                    ">
                    <div
                      class="table-row department-certificate-row"
                      [class.last-in-organization]="
                        isLastSectionGroup && isLast
                      "
                      [class.within-section]="true"
                      data-cy="department-certificate-row">
                      <div
                        class="table-cell main-label-cell sticky-main-cell-left department-certificate-row-cell"
                        [class.certificate-only-row]="
                          !isFirstCertificateForDepartment
                        "
                        [attr.data-cy]="
                          'dept-cert-row-' +
                          orgRow.organisation.id +
                          '-' +
                          departmentRow.id +
                          '-' +
                          certificateRow.id
                        ">
                        <div
                          class="department-certificate-label"
                          [class.certificate-only]="
                            !isFirstCertificateForDepartment
                          ">
                          <div
                            class="department-name"
                            *ngIf="isFirstCertificateForDepartment"
                            [title]="departmentRow.name">
                            {{ departmentRow.name }}
                          </div>
                          <div
                            class="certificate-name"
                            [title]="certificateRow.name">
                            <div
                              class="certificate-name-wrapper"
                              [title]="certificateRow.name">
                              {{ certificateRow.name }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <ng-container
                        *ngFor="let date of dateRangeDates$ | async">
                        <div
                          class="date-data-container"
                          [class.is-today]="
                            (date | date: 'yyyy.MM.dd') === getToday()
                          "
                          [class.is-weekend]="
                            (date | date: 'cc') === '6' ||
                            (date | date: 'cc') === '0'
                          "
                          [attr.data-cy]="
                            'data-container-' +
                            orgRow.organisation.id +
                            '-' +
                            departmentRow.id +
                            '-' +
                            certificateRow.id +
                            '-' +
                            date
                          ">
                          <div
                            *ngFor="let shiftInfo of effectiveShifts$ | async"
                            class="table-cell data-cell department-certificate-data-cell shift-column"
                            [class.certificate-only-data-cell]="
                              !isFirstCertificateForDepartment
                            "
                            [attr.data-cy]="
                              'shift-data-cell-' +
                              orgRow.organisation.id +
                              '-' +
                              departmentRow.id +
                              '-' +
                              certificateRow.id +
                              '-' +
                              date +
                              '-' +
                              shiftInfo.shift
                            ">
                            <div class="job-count-display">
                              <ng-container
                                *ngIf="
                                  departmentRow.jobs.byCertificates
                                    .get(certificateRow.id)
                                    ?.byDate?.get(date)
                                    ?.byShift?.get(shiftInfo.shift) as jobCount
                                ">
                                <div
                                  class="job-data-container"
                                  *ngIf="
                                    jobCount.open > 0 || jobCount.closed > 0
                                  "
                                  (click)="
                                    openJobDetailsSideSheet(
                                      jobCount.jobIds,
                                      date
                                    )
                                  "
                                  data-cy="clickable-job-count">
                                  <!-- Bar graph -->
                                  <div
                                    class="job-bar-graph"
                                    *ngIf="departmentRow.jobs.maxJobs > 0"
                                    [style.--max-count]="
                                      departmentRow.jobs.maxJobs
                                    "
                                    [style.--open-count]="jobCount.open"
                                    [style.--closed-count]="jobCount.closed">
                                    <div class="bar-container">
                                      <div class="bar-segment open-bar"></div>
                                      <div class="bar-segment closed-bar"></div>
                                    </div>
                                  </div>

                                  <!-- Job counts -->
                                  <div class="job-counts clickable-count">
                                    <span
                                      class="open-count"
                                      data-cy="open-count">
                                      {{
                                        jobCount.open > 0 ? jobCount.open : "-"
                                      }}
                                    </span>
                                    <span
                                      class="closed-count"
                                      data-cy="closed-count">
                                      {{
                                        jobCount.closed > 0
                                          ? jobCount.closed
                                          : "-"
                                      }}
                                    </span>
                                  </div>
                                </div>
                                <div
                                  class="job-data-container empty-cell"
                                  *ngIf="
                                    jobCount.open === 0 && jobCount.closed === 0
                                  ">
                                  <!-- Job counts -->
                                  <div class="job-counts">
                                    <span class="no-jobs-indicator">-</span>
                                  </div>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
            <!-- Department-certificate rows for this section -->
            <ng-container
              *ngFor="
                let departmentRow of orgRow.departments || [];
                let isLast = last
              ">
              <ng-container
                *ngFor="
                  let certificateRow of certificateRows$ | async;
                  let isFirstCertificateForDepartment = first;
                  let isLastCertificateForDepartment = last
                ">
                <div
                  class="table-row department-certificate-row"
                  [class.last-in-organization]="isLast"
                  [class.within-section]="true"
                  data-cy="department-certificate-row">
                  <div
                    class="table-cell main-label-cell sticky-main-cell-left department-certificate-row-cell"
                    [class.certificate-only-row]="
                      !isFirstCertificateForDepartment
                    "
                    [attr.data-cy]="
                      'dept-cert-row-' +
                      orgRow.organisation.id +
                      '-' +
                      departmentRow.id +
                      '-' +
                      certificateRow.id
                    ">
                    <div
                      class="department-certificate-label"
                      [class.certificate-only]="
                        !isFirstCertificateForDepartment
                      ">
                      <div
                        class="department-name"
                        *ngIf="isFirstCertificateForDepartment"
                        [title]="departmentRow.name">
                        {{ departmentRow.name }}
                      </div>
                      <div
                        class="certificate-name"
                        [title]="certificateRow.name">
                        <div
                          class="certificate-name-wrapper"
                          [title]="certificateRow.name">
                          {{ certificateRow.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <ng-container *ngFor="let date of dateRangeDates$ | async">
                    <div
                      class="date-data-container"
                      [class.is-today]="
                        (date | date: 'yyyy.MM.dd') === getToday()
                      "
                      [class.is-weekend]="
                        (date | date: 'cc') === '6' ||
                        (date | date: 'cc') === '0'
                      "
                      [attr.data-cy]="
                        'data-container-' +
                        orgRow.organisation.id +
                        '-' +
                        departmentRow.id +
                        '-' +
                        certificateRow.id +
                        '-' +
                        date
                      ">
                      <div
                        *ngFor="let shiftInfo of effectiveShifts$ | async"
                        class="table-cell data-cell department-certificate-data-cell shift-column"
                        [class.certificate-only-data-cell]="
                          !isFirstCertificateForDepartment
                        "
                        [attr.data-cy]="
                          'shift-data-cell-' +
                          orgRow.organisation.id +
                          '-' +
                          departmentRow.id +
                          '-' +
                          certificateRow.id +
                          '-' +
                          date +
                          '-' +
                          shiftInfo.shift
                        ">
                        <div class="job-count-display">
                          <ng-container
                            *ngIf="
                              departmentRow.jobs.byCertificates
                                .get(certificateRow.id)
                                ?.byDate?.get(date)
                                ?.byShift?.get(shiftInfo.shift) as jobCount
                            ">
                            <div
                              class="job-data-container"
                              *ngIf="jobCount.open > 0 || jobCount.closed > 0"
                              (click)="
                                openJobDetailsSideSheet(jobCount.jobIds, date)
                              "
                              data-cy="clickable-job-count">
                              <!-- Bar graph -->
                              <div
                                class="job-bar-graph"
                                *ngIf="departmentRow.jobs.maxJobs > 0"
                                data-cy="job-bar-graph"
                                [style.--max-count]="departmentRow.jobs.maxJobs"
                                [style.--open-count]="jobCount.open"
                                [style.--closed-count]="jobCount.closed">
                                <div class="bar-container">
                                  <div class="bar-segment open-bar"></div>
                                  <div class="bar-segment closed-bar"></div>
                                </div>
                              </div>

                              <!-- Job counts -->
                              <div class="job-counts clickable-count">
                                <span class="open-count">
                                  {{ jobCount.open > 0 ? jobCount.open : "-" }}
                                </span>
                                <span class="closed-count">
                                  {{
                                    jobCount.closed > 0 ? jobCount.closed : "-"
                                  }}
                                </span>
                              </div>
                            </div>
                            <div
                              class="job-data-container empty-cell"
                              *ngIf="
                                jobCount.open === 0 && jobCount.closed === 0
                              ">
                              <!-- Job counts -->
                              <div class="job-counts">
                                <span class="no-jobs-indicator">-</span>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="organisationRows.length === 0">
    <ng-container *ngIf="!(jobsLoading$ | async)">
      <div
        class="no-data-message"
        data-cy="no-data-message">
        {{ "noJobsFound" | i18n }}
      </div>
    </ng-container>
    <ng-container *ngIf="jobsLoading$ | async">
      <div class="loading-overlay">
        <div class="no-data-message">
          {{ ("loadingJobs" | i18n) || "Daten werden geladen..." }}
        </div>
        <mat-spinner diameter="48"></mat-spinner>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
<div
  class="side-sheet-overlay"
  [class.open]="sideSheetOpen"
  (click)="closeSideSheet()"
  data-cy="side-sheet-overlay">
  <div
    class="side-sheet"
    [class.open]="sideSheetOpen"
    (click)="$event.stopPropagation()"
    data-cy="side-sheet">
    <div class="side-sheet-header">
      <div class="side-sheet-title-wrapper">
        <h3
          class="side-sheet-title"
          data-cy="side-sheet-title">
          <ng-container
            *ngIf="
              selectedJobsDateQueryParams$ | async as selectedDate;
              else defaultTitle
            ">
            <ng-container
              *ngIf="selectedDate | date: 'dd.MM.yyyy' as formattedDate">
              {{ "jobsFromDate" | i18n: { datum: formattedDate } }}
            </ng-container>
          </ng-container>
          <ng-template #defaultTitle>
            {{ ("jobs" | i18n) || "Dienste" }}
          </ng-template>
        </h3>
      </div>
      <button
        class="side-sheet-close-button"
        type="button"
        (click)="closeSideSheet()"
        [attr.aria-label]="'Close'"
        mat-icon-button
        data-cy="side-sheet-close-button">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>

    <div class="side-sheet-content">
      <ng-container
        *ngIf="
          (jobMatrixFullJobsLoading$ | async) &&
            !(selectedJobs$ | async)?.length;
          else jobsLoaded
        ">
        <div class="loading-container">
          <mat-spinner
            diameter="48"
            data-cy="side-sheet-loading-spinner"></mat-spinner>
        </div>
      </ng-container>
      <ng-template #jobsLoaded>
        <ng-container *ngIf="selectedJobs$ | async as selectedJobs">
          <div
            *ngIf="selectedJobs.length === 0"
            class="no-jobs-message">
            {{ ("noJobsFound" | i18n) || "Keine Dienste gefunden" }}
          </div>
          <div
            *ngIf="selectedJobs.length > 0"
            class="jobs-list">
            <div
              class="job-items-container"
              *ngIf="loggedInUser?.role === roleEnum.DISPO">
              <app-dispo-job-list-item
                *ngFor="let job of selectedJobs; trackBy: trackByJobId"
                [job]="job"
                [loggedInUser]="readyDispoUser$ | async"
                [routerLink]="'/jobs/' + job._id"
                class="side-sheet-job-item"
                data-cy="side-sheet-job-item">
              </app-dispo-job-list-item>
            </div>
            <div
              class="job-items-container"
              *ngIf="loggedInUser?.role === roleEnum.REQUESTER">
              <app-job-request-item
                *ngFor="let job of selectedJobs; trackBy: trackByJobId"
                [jobRequest]="job"
                class="side-sheet-job-item"
                data-cy="side-sheet-job-item">
              </app-job-request-item>
            </div>
          </div>
        </ng-container>
      </ng-template>
    </div>
  </div>
</div>
